export enum CommunicationsResponseCreateOutboundCallError {
  invalidPhone = 'invalidPhone',
  invalidCallerId = 'invalidCallerId',
}
